export default {"src":"/_next/static/media/applePayMark.c5ca9eaa.svg","height":29,"width":43,"blurWidth":0,"blurHeight":0};